// src/pages/ComingSoon.js
//
// ═══════════════════════════════════════════════════════════════════════════
//  NEW FILE — 2026-09-19
//
//  WHY THIS EXISTS
//    Five items in the sidebar pointed at pages that were never built:
//      Email Sent · Servers Management · ESP Management ·
//      Data Management · Calc Email Setting
//    (plus "Settings" in the user dropdown in Header.js)
//
//    None of them had a route in App.js, so they fell through to the
//    catch-all rule:
//
//        <Route path="*" element={<Navigate to="/" replace />} />
//        <Route path="/" element={<Login />} />
//
//    …which meant clicking any of them dropped you on the LOGIN FORM.
//    Nothing was wrong with your session — it just looked exactly like
//    being logged out, which is alarming and wastes a minute every time.
//
//    This page is what they point at now. It says plainly that the page
//    isn't built yet, keeps the sidebar and header so you know where you
//    are, and gives you a way back.
// ═══════════════════════════════════════════════════════════════════════════

import { Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header  from "../components/Header";

/**
 * Props:
 *   title  — what to show as the page heading (e.g. "Servers Management")
 *   active — the sidebar item id to highlight (e.g. "servers"), so the menu
 *            still shows you where you are instead of highlighting nothing
 *   note   — optional extra line of context
 */
export default function ComingSoon({ title = "Coming Soon", active = null, note = null }) {
  return (
    <div className="layout">
      <Sidebar active={active}/>
      <div className="layout-main">
        <Header title={title}/>
        <div className="content">
          <div style={{
            minHeight: "58vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            gap: 14,
            padding: "40px 20px",
          }}>
            <div style={{
              width: 64, height: 64, borderRadius: "50%",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--bg-card, #fff)",
              border: "1px solid var(--border, #E5E7EB)",
              fontSize: 26,
            }}>
              🛠
            </div>

            <div style={{ fontSize: 20, fontWeight: 700, color: "var(--text-primary)" }}>
              {title}
            </div>

            <div style={{ fontSize: 14, color: "var(--text-secondary, #6B7280)", maxWidth: 420 }}>
              This section hasn't been built yet.
            </div>

            {note && (
              <div style={{ fontSize: 12.5, color: "var(--text-muted)", maxWidth: 420 }}>
                {note}
              </div>
            )}

            {/* A real app link — not <a href> — so going back doesn't reload
                the whole application. See the Sidebar.js change log. */}
            <Link to="/dashboard" style={{
              marginTop: 10,
              padding: "9px 22px",
              borderRadius: 8,
              background: "#D4A017",
              color: "#0A0A0F",
              fontWeight: 700,
              fontSize: 13,
              textDecoration: "none",
            }}>
              ← Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
